var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRobot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3946_15297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7054 12.8229C13.6481 12.8229 14.1194 12.8229 14.4121 12.5296C14.7054 12.2369 14.7054 11.7656 14.7054 10.8229C14.7054 9.88025 14.7054 9.40892 14.4121 9.11625C14.1201 8.82292 13.6487 8.82292 12.7054 8.82292M3.37207 12.8229C2.4294 12.8229 1.95807 12.8229 1.6654 12.5296C1.37207 12.2376 1.37207 11.7662 1.37207 10.8229C1.37207 9.87958 1.37207 9.40892 1.6654 9.11625C1.9574 8.82292 2.42874 8.82292 3.37207 8.82292M8.03874 4.15625C8.30395 4.15625 8.55831 4.05089 8.74584 3.86336C8.93338 3.67582 9.03874 3.42147 9.03874 3.15625C9.03874 2.89103 8.93338 2.63668 8.74584 2.44914C8.55831 2.26161 8.30395 2.15625 8.03874 2.15625C7.77352 2.15625 7.51917 2.26161 7.33163 2.44914C7.14409 2.63668 7.03874 2.89103 7.03874 3.15625C7.03874 3.42147 7.14409 3.67582 7.33163 3.86336C7.51917 4.05089 7.77352 4.15625 8.03874 4.15625ZM8.03874 4.15625V6.15625M6.03874 9.48958V10.1562M10.0387 9.48958V10.1562M12.7054 11.4896V10.1562C12.7054 8.27092 12.7054 7.32758 12.1194 6.74225C11.5341 6.15625 10.5907 6.15625 8.7054 6.15625H7.37207C5.48674 6.15625 4.5434 6.15625 3.95807 6.74225C3.37207 7.32758 3.37207 8.27092 3.37207 10.1562V11.4896C3.37207 13.3749 3.37207 14.3182 3.95807 14.9036C4.5434 15.4896 5.48674 15.4896 7.37207 15.4896H8.7054C10.5907 15.4896 11.5341 15.4896 12.1194 14.9036C12.7054 14.3182 12.7054 13.3749 12.7054 11.4896Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.70508 12.4922C6.70508 12.4922 7.14974 12.8255 8.03841 12.8255C8.92708 12.8255 9.37174 12.4922 9.37174 12.4922",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3946_15297"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.0371094 0.820312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRobot);
export default __webpack_public_path__ + "static/media/Icon_Robot.5ba764413bb1b295b30b7b3c23318fb7.svg";
export { ForwardRef as ReactComponent };